<template>
  <BasicModal
    :title="dialogTitle"
    :isShowModal="isShowModal"
    :canCancel="canCancel"
    @cancel="cancel">
    <!-- アラート -->
    <div class="alert-box">
      <ModalAlertDialog
        :isAlertDialogOpen="isAlertDialogOpen"
        :alertData="alertData"
        @alertResult="alertResult"
      />
    </div>
    <!-- テンプレートロボ雇用 -->
    <div class="robo-create-box">
      <!-- ロボ作成ダイアログ -->
      <TemplateToRobo
        :isCardModalActive="isShowRoboCreate"
        :createRoboName="createRoboName"
        :templateRobo="templateRobo"
        @cancel="showDialog"
        :PCTRLLOG="CTRLLOG"
      />
    </div>
    <!-- テンプレートロボ詳細 -->
    <div class="card" style="border-radius: 5px;">
      <div class="card-content">
        <div class="return-button-box">
          <button
            class="button is-primary return-button"
            @click="cancel(false)"
          >
            <span class="mdi mdi-undo"></span>
            戻る
          </button>
          <button
            class="button is-primary edit-button"
            @click="scenarioEdit()"
            v-show="user.companyName === 'テンプレートロボ作成会社'"
          >
            <span class="mdi mdi-account-edit"></span>
            シナリオ編集
          </button>
        </div>
        <div class="card-header">
          <!-- タグ -->
          <ChatBotTags
            :chatbot="templateRobo"
            :isEdit="false"
            :isNew="false"
            :isTemplate="true"
          />
        </div>
        <div class="card-body">
          <!-- サンプルデモ -->
          <div class="scenario-demo">
            <TemplateRoboScenarioDemo
              :templateRobo="templateRobo"
            />
          </div>
          <!-- 説明 -->
          <div class="description-text-box">
            <textarea
              readonly
              class="textarea description-text disp-scroll"
              cols=100
              v-model="templateRobo.tmp_description"
            >
            </textarea>
          </div>
          <!-- アイコン、ロボ名、パーツ数と編集パーツ数 -->
          <div class="robo-info-box">
            <!-- ロボアイコン -->
            <div class="icon-box">
              <img class="chatbot-icon" :src="getIconURL(templateRobo)">
            </div>
            <!-- ロボ名、パーツ数と編集パーツ数 -->
            <div class="info-box">
              <!-- ロボ名入力 -->
              <p class="robo-name-input-info">
                ロボ名を入力してください
              </p>
              <input type="text" class="robo-name-input" v-model="createRoboName" />
              <!-- 全パーツ数、編集パーツ数 -->
              <p class="robo-parts-info">
                全パーツ数：{{partsTotalNum}}　/　編集パーツ数：{{partsEditNum}}
              </p>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <a class="card-footer-item" @click="createRobo()">このロボを作成する</a>
        </div>
      </div>
    </div>
  </BasicModal>
</template>

<script>
import BasicModal               from '@/components/Modals/BasicModal'
import ChatBotTags              from '@/components2/Common/Screen/organisms/ChatBotTags'
import TemplateRoboScenarioDemo from '@/components2/Robo/modal/organisms/TemplateRoboScenarioDemo'
import TemplateToRobo           from '@/components2/Robo/modal/TemplateToRobo'
import ModalAlertDialog         from '@/components/organisms/common/ModalAlertDialog'
import controlLogMixin          from '@/mixins/controlLogMixin'
import {
  /** アラートダイアログ用定義 */
  ALERT_DEF,
  /** アラート表示データ作成 */
  createAlertData
} from '@/functions/common/alertFunc'

export default {
  name: 'TemplateRoboDetail',
  componentName: 'TemplateRoboDetail',
  components: {
    BasicModal,
    ChatBotTags,
    TemplateRoboScenarioDemo,
    TemplateToRobo,
    ModalAlertDialog
  },
  mixins: [
    controlLogMixin,
  ],
  props: {
    /**
     * ロボ雇用ダイアログ開閉フラグ
     * @type  {Object}
     */
    isShowModal: {
      type: Boolean,
      default: false,
      required: true
    },
    /**
     * テンプレートロボ
     * @type  {Object}
     */
    templateRobo: {
      type: Object,
      required: true
    },
    /**
     * ユーザー情報
     * @type  {Object}
     */
    user: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      /**
       * コンポーネント名
       * @type {String}
       */
      COMPONENT_NAME: 'TemplateRoboDetail',
      /**
       * ダイアログタイトル
       * @type {String}
       */
      dialogTitle: 'ロボ雇用',
      /**
       * アラートダイアログ表示フラグ(true：表示、false：非表示)
       * @type {Boolean}
       */
      isAlertDialogOpen: false,
      /**
       * アラートダイアログ表示データ
       * @type {Object}
       */
      alertData: {},
      /**
       * ロボ作成ダイアログ開閉フラグ
       * @type {Boolean}
       */
      isShowRoboCreate: false,
      /**
       * 新規作成ロボ名
       * @type {String}
       */
      createRoboName: '',
      /**
       * ダイアログタイトル
       * @type {String}
       */
      dialogTitle: 'ロボ雇用',
      /**
       * 全パーツ数
       * @type {Number}
       */
      partsTotalNum: 0,
      /**
       * 編集パーツ数
       * @type {Number}
       */
      partsEditNum: 0,
      /**
       * can-cancelイベント制御
       * @type {Boolean}
       */
      canCancel: true
    }
  },
  mounted () {
    // 全パーツ数
    this.partsTotalNum = this.templateRobo.scenarioList.length

    // 編集パーツ数(ロックされていないパーツ)
    this.partsEditNum = this.templateRobo.scenarioList.filter(scenario => scenario.is_confirm === false).length
  },
  watch: {
    isShowRoboCreate () {
      // モーダルを開いていても、Escapeキーは拾ってしまうので制御する
      if (this.isShowRoboCreate === true) {
        // ロボ作成ダイアログが開いている時はcan-cancelは無効にする
        this.canCancel = false
      } else {
        // ロボ作成ダイアログが閉じている時はcan-cancelを有効にする
        this.canCancel = true
      }
    }
  },
  methods: {
    /**
     * アイコン表示
     * @param {Object} robo ロボ
     */
    getIconURL (robo) {
      if (robo && robo.icon_data) {
        return robo.icon_data
      } else {
        return require('@/assets/template/robot.png')
      }
    },
    /**
     * ロボ作成
     */
    createRobo () {
      if (!this.createRoboName) {
        this.roboNameNotInput()
        return
      }
      this.showDialog(true)
    },
    /**
     * ロボ作成ダイアログ開閉
     */
    showDialog (flag) {
      this.isShowRoboCreate = flag
    },
    /**
     * ロボ台数上限アラートダイアログ表示
     */
    roboNameNotInput () {
      // アラート表示データ
      const alertData = createAlertData(
        // タイトル
        'ロボ名が未入力です',
        // 本文
        'ロボ名を入力してください',
        // アラートの種類
        ALERT_DEF.MESSAGE_WARNING,
        // ダイアログの種類
        ALERT_DEF.DIALOG_ALERT,
        // 表示元キーワード
        this.COMPONENT_NAME,
        // 表示元分類キーワード
        'robo-name-not-input'
      )

      // アラート表示
      this.alertData = alertData
      this.isAlertDialogOpen = true
    },
    /**
     * アラートダイアログ操作結果
     * @param {Object} alertResultData アラートダイアログ操作結果
     */
    alertResult (alertResultData) {
      if (alertResultData) {
        // アラート結果データあり
        if (alertResultData.alertResultValue === ALERT_DEF.RESULT_OK) {
          this.isAlertDialogOpen = false
        }
      }
    },
    /**
     * キャンセル
     */
    cancel () {
      this.$emit('cancel', false)
    },
    /**
     * テンプレートロボのシナリオ編集画面に遷移
     */
    scenarioEdit () {
      // シナリオ編集画面に遷移
      this.$router.push('/dashboard/chatbot?view=scenario&scenario=' + this.templateRobo.scenario_name + '&is_template=true')
      this.cancel()
    },
  }
}
</script>

<style lang="scss" scoped>
.return-button-box {
  padding: 8px;
  padding-right: 32px;
  margin-right: 10px;
  .return-button {
    height: 32px;
    position: absolute;
    right: 16px;
  }
  .edit-button {
    height: 32px;
    position: absolute;
    right: 100px;
  }
}
.alert-box {
  display: flex;
}
.robo-create-box {
  display: flex;
}
.image-box {
  position: absolute;
}
.scenario-demo {
  height: calc(100hv - 400px);
  padding-bottom: 16px;
}
.description-text-box {
  padding-bottom: 16px;
  .description-text {
    min-height: 88px;
    max-height: 88px;
  }
}
.robo-info-box {
  width: 100%;
  padding-right: 16px;
  display: flex;
  align-items: center;
  position: relative;
  .icon-box {
    width: 30%;
    padding: 16px;
    justify-content: center;
    margin-right: auto;
    display: flex;
    align-items: center;
    position: relative;
    .chatbot-icon {
      width: 100px;
      height: 100px;
      object-fit: cover;
      border-radius: 50%;
      border: solid thin #ccc;
    }
  }
  .info-box {
    width: 70%;
    margin-left: auto;
    padding-left: 4px;
    .robo-name-input-info {
      padding: 6px;
      font-size: 18px;
    }
    .robo-name-input {
      width:100%;
      height: 36px;
      font-size: 18px;
    }
    .robo-parts-info {
      padding: 6px;
      font-size: 16px;
      text-align: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components2/Robo/modal/TemplateRoboDetail.vue